import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {VehicleModelWithActiveShift} from '../../../shared/models/vehicle.model';
import {VehicleCategoryModel} from '../../../shared/models/vehicle';
import {RouteConfigurationWithSchema} from '../../../shared/models/route';

@Injectable({
    providedIn: 'root',
})
export class LiveMapDataService {

    private vehicleCategoriesSource = new BehaviorSubject<VehicleCategoryModel[]>([]);
    readonly vehicleCategories$ = this.vehicleCategoriesSource.asObservable();

    private vehiclesSource = new BehaviorSubject<VehicleModelWithActiveShift[]>([]);
    vehicles$ = this.vehiclesSource.asObservable();

    private routeConfigurationSource = new BehaviorSubject<RouteConfigurationWithSchema[]>([]);
    routeConfiguration$ = this.routeConfigurationSource.asObservable();

    sendVehicleCategories(data: VehicleCategoryModel[]) {
        this.vehicleCategoriesSource.next(data);
    }

    sendVehicles(data: VehicleModelWithActiveShift[]) {
        this.vehiclesSource.next(data);
    }

    sendRouteConfiguration(data: RouteConfigurationWithSchema[]) {
        this.routeConfigurationSource.next(data);
    }
}
